// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2CZ7h","rootMobile":"styles_rootMobile__15f2B"};